import { useContext } from 'react';
import { StrategyContext } from '../Context/StrategyContext';

export function useStrategy() {
  const context = useContext(StrategyContext);

  return context;
}
